import React, { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Select from 'react-select';
import FullQualifiedClientId from '../../../../Various/FullQualifiedClientId';

const NewCampaignModal = ({ 
    show, 
    onHide, 
    onSubmit, 
    wsProvider 
}) => {
    const [newCampaignData, setNewCampaignData] = useState({
        client_id: '',
        campaign_name: ''
    });

    const handleClose = () => {
        setNewCampaignData({
            client_id: '',
            campaign_name: ''
        });
        onHide();
    };

    const handleSubmit = () => {
        if (!newCampaignData.client_id || !newCampaignData.campaign_name) {
            return;
        }

        onSubmit(newCampaignData);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create New Campaign</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form>
                    <div className="mb-3">
                        <label htmlFor="clientSelect" className="form-label">Select Client</label>
                        <Select
                            className="reactSelect"
                            id="clientSelect"
                            value={{ value: newCampaignData.client_id, label: newCampaignData.client_id }}
                            onChange={(selected) => setNewCampaignData({...newCampaignData, client_id: selected.value})}
                            options={[
                                { value: "", label: "Choose a client..." },
                                ...wsProvider.clients.map((client) => ({
                                    value: client.client,
                                    label: client.client
                                }))
                            ]}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="campaignName" className="form-label">Campaign Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="campaignName"
                            value={newCampaignData.campaign_name}
                            onChange={(e) => setNewCampaignData({...newCampaignData, campaign_name: e.target.value})}
                            placeholder="Enter campaign name"
                        />
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    onClick={handleSubmit}
                    disabled={!newCampaignData.client_id || !newCampaignData.campaign_name}
                >
                    Create Campaign
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default NewCampaignModal; 